import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';
import { PartRegion } from '@/features/storefront/parts/PartRegion';

/**
 * A toy shop's product page: the picture and the buy column at an even split,
 * the column sticking beside the picture on a wide screen so "Add to cart" is
 * never a scroll away. The breadcrumb above and the related toys below are
 * drawn by the page itself at its own width.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-8 lg:grid-cols-2 lg:gap-14">
    <PartRegion name="gallery" className="min-w-0" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-28 lg:self-start" />
  </StorefrontContainer>
);
